import {FC, ReactNode} from 'react';
import cx from 'classnames';
//mui
import {Box, LinearProgressProps, LinearProgress as MuiLinearProgress} from '@mui/material';
//constants
import {DETERMINATE} from '@/utils/constants';
//styles
import styles from './styles.module.scss';

interface ExtendedProgressBarProps extends Omit<LinearProgressProps, 'title'> {
	value: number;
	title?: ReactNode;
	parentClassName?: string;
}

const ProgressBar: FC<ExtendedProgressBarProps> = ({value, parentClassName, title, variant, ...rest}) => {
	return (
		<Box className={cx(parentClassName, styles.wrapper)}>
			{title}
			<MuiLinearProgress {...rest} variant={DETERMINATE} value={value} />
		</Box>
	);
};

export default ProgressBar;
